import {Component, ElementRef, inject, OnDestroy, OnInit, viewChild} from '@angular/core';
import {WidgetComponent} from './widget/widget.component';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {Chart} from 'chart.js';
import {wrapGrid} from 'animate-css-grid';
import {Dashboard} from './models/dashboard';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DashboardStore } from './stores/dashboard.store';

@Component({
    selector: 'app-dashboard',
    providers: [HttpClient],
    imports: [
        WidgetComponent,
        MenuModule,
        MenubarModule,
        FormsModule,
        CommonModule
    ],  
    standalone: true,
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit, OnDestroy {
  dashboard = viewChild.required<ElementRef>('dashboard');
  store = inject(DashboardStore);
  route = inject(ActivatedRoute);

  dashboard$!: Observable<Dashboard>;
    
  clearAnimations = () => {};

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.dashboard$ = of(data['dashboard']); // kommt vom Resolver
    });

    const { unwrapGrid } = wrapGrid(this.dashboard().nativeElement, {
      duration: 300,
    });
    this.clearAnimations = unwrapGrid;

    Chart.defaults.color = 'white';
  }

  ngOnDestroy() {
    this.clearAnimations();
  }
}
